import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormLabel,
  Grid,
  IconButton,
  makeStyles,
  MenuItem,
  Select,
  Snackbar,
  Theme,
  Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import {Alert} from "@material-ui/lab";
import React, {useEffect, useRef, useState} from "react";
import {CloseIcon, CloseIconColor, ExpandIconTwo} from "../../Icons";
import {TextBar} from "../TextBar";
import {primaryBlue, primaryGray, textBarColor} from "../../colors";
import {environment} from "src/environments/environment";
import DeviceSettingUpdatePopup from "./DeviceSettingUpdatePopup";
import axios from "axios";
import useStyles from "src/app/maintenance/assets/styles";
import { checkDefaultValueFormat } from "../../../app/maintenance/remote-manager/RemoteManagerValidations";
import Cookies from "js-cookie";

const EditConfiguration = (props) => {
  const device = props.device.device.deviceParameterConfiguration;
  const {productType, versionNum, deviceCategory} =
    props.device.device.deviceParameterConfiguration;
  let sortedDetailsArray = [];
  let joinParameters={}
  if(props.device.device.deviceParameterConfiguration.remoteConfigurations){
   sortedDetailsArray =
    props.device.device.deviceParameterConfiguration.remoteConfigurations.sort(
      (a, b) => a.id - b.id
    );
  joinParameters =
    props.device.device.deviceParameterConfiguration.joinParameters?props.device.device.deviceParameterConfiguration.joinParameters:{};
  }
  const [detailsArray, setDetailsArray] = useState(sortedDetailsArray);
  const constDetailsArray = sortedDetailsArray;
  const [openIcon1, setOpenIcon1] = useState(false);
  const [openIcon2, setOpenIcon2] = useState(false);
  const [openIcon3, setOpenIcon3] = useState(false);

  const [parametersToEdit, setParametersToEdit] = useState([]);
  const [updateMsgOpen, setUpdateMsgOpen] = useState(false);
  const contentContainerRef = useRef(null);
  const [passwordVisible, setPasswordVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [changesMade, setChangesMade] = useState(false);
  const [message, setMessage] = useState('');
  const [toaster, setToaster] = useState(false);
  const [msgSuccess, setMsgSuccess] = useState(false);
  // useEffect(() => {
  //   if (updateMsgOpen) {
  //     contentContainerRef.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }
  // }, [updateMsgOpen]);

  const localStyles = makeStyles((theme: Theme) => ({
    container: {
      paddingTop: "20px",
    },
    input: {
      width: "100%",
      height: "40px",
      backgroundColor: "#F4F5F7",
    },
    label: {
      fontSize: "14px",
      color: primaryGray,
      paddingBottom: "5px",
    },
    helperText: {
      color: "red",
    },
    divider: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      height: 1,
      width: "100%",
    },
    textBarStyle: {
      backgroundColor: textBarColor,
      height: "44px",
    },
    textBarMessageStyle: {
      width: "219px",
      backgroundColor: textBarColor,
      height: "44px",
    },
    labelMessage: {
      fontSize: "14px",
      color: primaryGray,
      paddingBottom: "5px",
      width: "121px",
    },
    select: {
      width: "252px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      backgroundColor: textBarColor,
      height: "44px",
      padding: "4px",
      fontSize: "14px",
    },
    menuItem: {
      fontSize: "14px",
    },
  }));

  const classes = localStyles();
  const style =  useStyles();
  const handleCloseToaster = () => {
    setToaster(false);
  };

    const updateParamErrors = (prevArray) => {
      let isValidParamValues=true;
      const arrayResults= prevArray.map((detail) => {
        if (detail.checkUpdate){
          const validationResult = checkDefaultValueFormat(detail.format, detail.defaultValue,detail.parameter);
          if(validationResult.error){
            isValidParamValues=false;
          }
          return validationResult.error
            ? { ...detail, errorMsg: validationResult.errorMsg }
            : { ...detail, errorMsg: "" };
        }
        return detail;
      });
      return {detailsArrayErrors:arrayResults,isValid:isValidParamValues}

    };


  const handleSaveClick = () => {
    const networkAndCommunicationParams = {};
    const topicFormatParams = {};
    const messageFormatParams = {};
    const uId = Cookies.get("USER_ID");
    const validateParam=updateParamErrors(detailsArray);
    if(!validateParam.isValid){
      setDetailsArray(validateParam.detailsArrayErrors);
      return;
    }
    detailsArray.forEach((item) => {    
      if (item.checkUpdate === true) {
        switch (item.parameterCategory) {
          case "Network & Communication":
            networkAndCommunicationParams[item.parameter] = item.defaultValue;
            break;
          case "Topic Format & Interval":
            topicFormatParams[item.parameter] = item.defaultValue;
            break;
          case "Message Format":
            messageFormatParams[item.parameter] = item.defaultValue;
            break;
          default:
            break;
        }
      }
    });

    const updateHistory = {
      actionBy: Cookies.get("USERNAME"),
      networkAndCommunication: networkAndCommunicationParams,
      topicFormat: topicFormatParams,
      messageFormat: messageFormatParams,
    };

    const data = {
      productType,
      versionNum,
      deviceCategory,
      remoteConfigurations: detailsArray.filter((detail) => detail.checkUpdate).map(({checkUpdate,errorMsg, ...item}) => ({
        ...item,
        defaultValue:item.defaultValue,
      })),
      updateHistory: [updateHistory],
    };
    setLoading(true);
    axios.put(`${environment.host}/core/device/deviceParameterConfiguration/${props.device.device.id}/user/${uId}`, data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
        },
      })
      .then((response) => {
        if (
          (Object.keys(networkAndCommunicationParams).length > 0 ||
            Object.keys(topicFormatParams).length > 0 ||
            Object.keys(messageFormatParams).length > 0) &&
          response.data.message === "Success"
        ) {
          setUpdateMsgOpen(true);
          setTimeout(() => {
            setUpdateMsgOpen(false);
            setLoading(false);
            props.onClose();
          }, 2000);
        }
      })
      .catch((error) => {
        setLoading(false);
        setMessage(error.response.data.message);
        setMsgSuccess(false);
        setToaster(true);
        setTimeout(() => {
            setToaster(false); 
        }, 2000); 
        console.error(error);
      });
  };

  const readChips = () => {
  };

  const updateDetailsArray = (prevState, index, value) => {
    return prevState.map((detail, i) =>
      i === index
        ? {...detail, defaultValue: value, checkUpdate: true}
        : detail
    );
  };

  const updateParamsToAdd = (
    detailsArray,
    constDetailsArray,
    joinParameters
  ) => {
    const paramsToAdd = [];

    //todo:optimize this
    for (const paramId of Object.keys(joinParameters)) {
      const paramValueArray = Array.isArray(joinParameters[paramId])
        ? joinParameters[paramId]
        : [];
      const matchingDetail = detailsArray.find(
        (detail) => detail.id === paramId
      );
      const constMatchingDetail = constDetailsArray.find(
        (constDetail) => constDetail.id === paramId
      );
      if (matchingDetail.defaultValue !== constMatchingDetail.defaultValue) {
        for (const id of paramValueArray) {
          const matchingDetail = detailsArray.find(
            (detail) => detail.id === id
          );
          const constMatchingDetail = constDetailsArray.find(
            (constDetail) => constDetail.id === id
          );

          if (
            matchingDetail &&
            constMatchingDetail &&
            matchingDetail.defaultValue === constMatchingDetail.defaultValue
          ) {
            paramsToAdd.push(matchingDetail.parameter);
          }
        }
      }
    }
    return paramsToAdd;
  };
  const handleCloseUpdateMsg = () => {
    setUpdateMsgOpen(false);
  };
  const handleInputChange = (event, index) => {
    const {value} = event.target;
    const trimmedValue = value.trim();
    setDetailsArray((prevState) => {
      const updatedDetailsArray = updateDetailsArray(
        prevState,
        index,
        trimmedValue
      );
      const updatedParamsToAdd = updateParamsToAdd(
        updatedDetailsArray,
        constDetailsArray,
        joinParameters
      );
      setParametersToEdit(updatedParamsToAdd);

      setChangesMade(true);
      return updatedDetailsArray;
    });
  };

  const handleSelectChange = (event, index) => {
    const {value} = event.target;
    setDetailsArray((prevState) => {
      const updatedDetailsArray = prevState.map((detail, i) => {
        if (i === index) {
          return {
            ...detail,
            defaultValue: value,
            checkUpdate: true,
          };
        } else {
          return detail;
        }
      });
      const updatedParamsToAdd = updateParamsToAdd(
        updatedDetailsArray,
        constDetailsArray,
        joinParameters
      );
      setParametersToEdit((prevParams) => [
        ...new Set([...prevParams, ...updatedParamsToAdd]),
      ]);
      setChangesMade(true);
      return updatedDetailsArray;
    });
  };

  const keyOrder = ["productType", "versionNum", "deviceCategory", "deviceIds"];

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        fullWidth={true}
        maxWidth={"md"}
        style={{width: "766px", height: "591px"}}
        BackdropProps={{
          style: {
            backgroundColor: "cubic-bezier(0.4, 0, 0.1, 1)",
            opacity: "0.4",
          },
        }}
        PaperProps={{
          // className: classes.paper,
          style: {
            boxShadow: "inherit",
          },
        }}
      >
        <Grid
          container
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: "1",
            boxShadow: "0px 4px 30px #00000008",
          }}
        >
          <Grid item xs={10} md={10}>
            <DialogTitle>Edit Configuration</DialogTitle>
          </Grid>
          <Grid
            item
            xs={2}
            md={2}
            className={style.customCloseIcon}
          >
            <IconButton onClick={props.onClose}>
              <CloseIconColor/>
            </IconButton>
          </Grid>
        </Grid>
        <Divider/>
        <>
          <DialogContent>
            <Grid container className={classes.container}>
              {!updateMsgOpen &&
                keyOrder.map((key, id) => {
                  var label = "";
                  if (key === "productType") {
                    label = "Product Type";
                  } else if (key === "versionNum") {
                    label = "Version";
                  } else if (key === "deviceCategory") {
                    label = "Device Category";
                  } else if (key === "deviceIds") {
                    label = "Device IDs";
                  } else {
                    label = key;
                  }
                  if (device.hasOwnProperty(key)) {
                    return (
                      <Grid
                        key={id}
                        item
                        xs={6}
                        md={12}
                        style={{
                          textAlign: "left",
                          marginBottom: "22px",
                          paddingRight: "2%",
                        }}
                      >
                        <Typography
                          style={{
                            fontFamily: "Poppins",
                            fontWeight: "normal",
                            fontStyle: "normal",
                            fontSize: "16px",
                            lineHeight: "25px",
                            color: primaryGray,
                          }}
                        >
                          {label}
                        </Typography>
                        <TextBar
                          disabled={true}
                          variant="outlined"
                          defaultValue={device[key]}
                          error={{error: false}}
                          style={classes.textBarStyle}
                        />
                      </Grid>
                    );
                  }
                })}

              <Grid
                container
                className={classes.container}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  paddingRight:"10px"
                }}
              >
                <Grid item xs={4} md={4}>
                  <FormLabel
                    style={{
                      color: primaryGray,
                      opacity: "1",
                      textAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "start",
                    }}
                  >
                    Network & Communication
                  </FormLabel>
                </Grid>
                <Grid item xs={7} md={7}>
                  <Divider className={classes.divider}/>
                </Grid>
                <Grid
                  item
                  xs={1}
                  md={1}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    style={{
                      backgroundColor: "ButtonShadow",
                      borderRadius: "80%",
                      boxShadow: "0px 3px 6px #00000029",
                      padding: "3px",
                    }}
                    onClick={() => setOpenIcon1(!openIcon1)}
                  >
                    <ExpandIconTwo rotation={openIcon1}/>
                  </IconButton>
                </Grid>
              </Grid>
              {/* /////////////////////////////////////////////////////////////////// */}

              {openIcon1 === true && (
                <Grid
                  container
                  className={classes.container}
                  style={{
                    margin: "auto",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {detailsArray.map((item, id) => {
                    if (item.parameterCategory === "Network & Communication") {
                      /*let combinedValues = [];
                      if (item.defaultValues && item.defaultValues.length > 0) {
                        combinedValues = [
                          item.defaultValue,
                          ...item.defaultValues,
                        ];
                      } */
                      return (
                        <Grid
                          key={id}
                          item
                          xs={6}
                          md={12}
                        className={style.customLabel}
                        >
                          <Typography
                           className={style.typographyStyle}
                          >
                            {item.parameter.charAt(0).toUpperCase() +
                              item.parameter.slice(1)}
                          </Typography>
                          {item.parameterId == "6" ? (
                            <div
                              style={{display: "flex", alignItems: "center"}}
                            >
                              <input
                                type={passwordVisible ? "text" : "password"}
                                value={item.defaultValue}
                                onChange={(event) =>
                                  handleInputChange(event, id)
                                }
                                style={{
                                  width: "228px",
                                  marginLeft: "20px",
                                  backgroundColor: textBarColor,
                                  height: "44px",
                                  border: "none",
                                  outline: "none",
                                }}
                              />
                              <IconButton
                                onClick={() =>
                                  setPasswordVisible(!passwordVisible)
                                }
                                style={{marginLeft: "10px"}}
                              >
                                {passwordVisible ? (
                                  <VisibilityOffIcon/>
                                ) : (
                                  <VisibilityIcon/>
                                )}
                              </IconButton>
                            </div>
                          ) : (
                            <TextBar
                              style={classes.textBarStyle}
                              defaultValue={item.defaultValue}
                              error={{error: false}}
                              onChange={(event) => handleInputChange(event, id)}
                            />
                          )}
                           <Typography className={style.errorText} >{item.errorMsg&&item.errorMsg}</Typography>
                        </Grid>
                      );
                    }
                  })}
                </Grid>
              )}

              <Grid
                container
                className={classes.container}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  paddingRight:"10px"
                }}
              >
                <Grid item xs={4} md={4}>
                  <FormLabel
                    style={{
                      color: primaryGray,
                      opacity: "1",
                      textAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "start",
                    }}
                  >
                    Topic Format & Interval
                  </FormLabel>
                </Grid>
                <Grid item xs={7} md={7}>
                  <Divider className={classes.divider}/>
                </Grid>
                <Grid
                  item
                  xs={1}
                  md={1}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    style={{
                      backgroundColor: "ButtonShadow",
                      borderRadius: "80%",
                      boxShadow: "0px 3px 6px #00000029",
                      padding: "3px",
                    }}
                    onClick={() => setOpenIcon2(!openIcon2)}
                  >
                    <ExpandIconTwo rotation={openIcon2}/>
                  </IconButton>
                </Grid>
              </Grid>
              {/* //////////////////////////////////////////////////// */}

              {openIcon2 === true && (
                <Grid container className={classes.container}>
                  {detailsArray.map((item, id) => {
                    if (item.parameterCategory === "Topic Format & Interval") {
                    

                      return (
                        <Grid
                          key={id}
                          item
                          xs={6}
                          md={12}
                          className={style.customLabel}
                        >
                          <Typography
                           className={style.typographyStyle}
                          >
                            {item.parameter.charAt(0).toUpperCase() +
                              item.parameter.slice(1)}
                          </Typography>
                          
                            <TextBar
                              style={classes.textBarStyle}
                              defaultValue={item.defaultValue}
                              error={{error: false}}
                              onChange={(event) => handleInputChange(event, id)}
                            />
                           <Typography className={style.errorText} >{item.errorMsg&&item.errorMsg}</Typography>
                        </Grid>
                      );
                    }
                  })}
                </Grid>
              )}

              <Grid
                container
                className={classes.container}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  paddingRight:"10px"
                }}
              >
                <Grid item xs={4} md={4}>
                  <FormLabel
                    style={{
                      color: primaryGray,
                      opacity: "1",
                      textAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "start",
                    }}
                  >
                    Message Format
                  </FormLabel>
                </Grid>
                <Grid item xs={7} md={7}>
                  <Divider className={classes.divider}/>
                </Grid>
                <Grid
                  item
                  xs={1}
                  md={1}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    style={{
                      backgroundColor: "ButtonShadow",
                      borderRadius: "80%",
                      boxShadow: "0px 3px 6px #00000029",
                      padding: "3px",
                    }}
                    onClick={() => setOpenIcon3(!openIcon3)}
                  >
                    <ExpandIconTwo rotation={openIcon3}/>
                  </IconButton>
                </Grid>
              </Grid>
              {/* //////////////////////////////////////////////////// */}

              {openIcon3 === true && (
                <Grid container className={classes.container}>
                  {detailsArray.map((item, id) => {
                    if (item.parameterCategory === "Message Format") {
                     
                      return (
                        <Grid
                          key={id}
                          item
                          xs={6}
                          md={12}
                        className={style.customLabel}
                        >
                          <Typography
                            className={style.typographyStyle}
                          >
                            {item.parameter.charAt(0).toUpperCase() +
                              item.parameter.slice(1)}
                          </Typography>
                            <TextBar
                              style={classes.textBarStyle}
                              defaultValue={item.defaultValue}
                              error={{error: false}}
                              onChange={(event) => handleInputChange(event, id)}
                            />
                             <Typography className={style.errorText} >{item.errorMsg&&item.errorMsg}</Typography>
                        </Grid>
                      );
                    }
                  })}
                </Grid>
              )}
              <DialogContent
                className={classes.container}
                style={{
                  width: "100%",
                  paddingBottom: "20px",
                  paddingRight:"0px",
                  display: "flex",
                }}
              >
                <Grid item xs={12} md={12}>
                  <DialogActions
                    style={{
                      justifyContent: "end",
                      display: "flex  ",
                    }}
                  >
                    <Button
                      onClick={props.onClose}
                      className={style.backButton}
                      variant="outlined"
                    >
                      Cancel
                    </Button>
                    <Button
                      className={style.saveButton}
                      style={{color:"white"}}
                      onClick={() => {
                        handleSaveClick();
                      }}
                      disabled={!changesMade }
                    >
                      {loading ? (
                        <CircularProgress size={24} color="inherit"/>
                      ) : (
                        "Update"
                      )}
                    </Button>
                  </DialogActions>
                </Grid>
              </DialogContent>
            </Grid>
          </DialogContent>
        </>
        <div>
      <Snackbar
        open={toaster}
        autoHideDuration={6000}
        onClose={handleCloseToaster}
        anchorOrigin={{vertical: "bottom", horizontal: "right"}}
      >
        <Alert
          onClose={handleCloseToaster}
          severity={msgSuccess === true ? "success" : "error"}
        >
          {message}
        </Alert>
      </Snackbar>
          {parametersToEdit.length > 0 && (
            <Snackbar
              key="parameterEditAlert"
              open={true}
              autoHideDuration={6000}
              onClose={() => setParametersToEdit([])}
            >
              <Alert severity="warning" onClose={() => setParametersToEdit([])}>
                You need to edit the following parameters:{" "}
                {parametersToEdit.join(",")}
              </Alert>
            </Snackbar>
          )}
          
<Snackbar 
  key="successAlert"   
  open={updateMsgOpen} 
  autoHideDuration={6000}
  onClose={handleCloseUpdateMsg}
  onClick={handleCloseUpdateMsg}  
  anchorOrigin={{vertical: "bottom", horizontal: "right"}}
>
  <Alert 
    severity="success"
    onClose={handleCloseUpdateMsg}
  >
    <h3>{`Product Type : ${productType} -> Device : ${props.device.device.id} `}</h3>
    <p>{`Config message sent with following updated values`}</p>
    {detailsArray.map((item, index) => {
      if (item.checkUpdate) {
        return (
          <li key={index}>
            {item.parameter} : {item.defaultValue}
          </li>
        );
      }
      return null;})}
  </Alert>
</Snackbar>

        </div>
      </Dialog>
    </div>
  );
};

export default EditConfiguration;
